// extracted by css-extract-rspack-plugin
export default {"badgesContainer":"BadgesContainer_badgesContainer__o1bAs"};